import { parsePhoneNumber } from 'libphonenumber-js'

export const setErrors = (item, props, value) => {
    props.forEach(prop => {
        item[prop] = value
    });

    return item;
}

export const hasErrors = (errors, arr) => {
    let value = arr.some(item => {
        return errors[item] === true;
    });

    return value;
}

export const isEmailValid = (value) => {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !regex.test(String(value).toLowerCase()) ? false : true;
}

export const isPhoneValid = (value) => {
    // Match any character that is not a digit, whitespace, hyphen (-) or plus sign (+)
    const regex = /[^\d\s-+]/;

    if (regex.test(value, regex)) {
        return false;
    }

    try {
        const phoneNr = parsePhoneNumber(value, 'SE');
        const isValid = phoneNr.isValid();
        return isValid;
    } catch (err) {
        return false;
    }
}

export const isPostalValid = (value) => {
    const regex = /(^\d{3} \d{2})|(^\d{5})$/;
    return !regex.test(value) ? false : true;
}

export const isPostalWithCityValid = (value) => {
    const regex = /(((^\d{3} \d{2})|(^\d{5}))\s([A-ZÅÄÖ]+)\s*)$/i;
    return !regex.test(value) ? false : true;
}

export const isSocialSecurityNumberValid = value => {
    const regex = /^(19|20)?(\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([-]?|[\s]?)\d{4})$/
    return regex.test(value)
}



// WEBPACK FOOTER //
// ./src/helpers/error-validation.js